import { createAsyncThunk } from '@reduxjs/toolkit';
import googleApi from '~/apis/google';
import { GET_GOOGLE_DETAIL, GET_GOOGLE_SEARCH } from '~/utils/constants/actionType';
import { IParamsGoogleSearch } from '~/utils/interface/google';

export const handleGetGoogleSearch = createAsyncThunk<any, IParamsGoogleSearch>(
  GET_GOOGLE_SEARCH,
  async (params: IParamsGoogleSearch, { rejectWithValue }) => {
    try {
      const res = await googleApi.getGoogleMapsSearch(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetGoogleMapsDetail = createAsyncThunk<any, IParamsGoogleSearch>(
  GET_GOOGLE_DETAIL,
  async (params: IParamsGoogleSearch, { rejectWithValue }) => {
    try {
      const res = await googleApi.getGoogleMapsDetail(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
